import { createSlice } from "@reduxjs/toolkit";

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    rooms: [], // Stores chat room list
  },
  reducers: {
    setRooms: (state, action) => {
      state.rooms = action.payload; // Replace with new chat rooms
    },
  },
});

export const { setRooms } = chatSlice.actions;
export default chatSlice.reducer;
